var lib_core = require("lib-core");
var jquery = require("jquery");

if(typeof window !== 'undefined')
    require("jquery.browser");

var LoadingWatchdogModel = function (options) {
    var self = this;
    lib_core.Model.call(this);


    if(typeof window !== 'undefined')
        this.watchdog = setTimeout(() => {
            if(!jquery.browser.chrome)
                logError("Loader watchdog", new Error("app took too long to load"), logError.criticality.MAJOR,
                    "This document is taking a while to load. For the best experience, use Chrome.");
            else
                logError("Loader watchdog", new Error("app took too long to load"), logError.criticality.MINOR,
                    "This document is taking a while to load.");
        }, options.timeout);
};
lib_core.inherit(LoadingWatchdogModel, lib_core.Model);
LoadingWatchdogModel.$class = "LoadingWatchdogModel";

module.exports = LoadingWatchdogModel;
